import { HTMLAttributes } from 'react';

export type SpinnerProps = HTMLAttributes<HTMLDivElement> &
  SpinnerComponentProps;

export interface SpinnerComponentProps {
  size?: SpinnerSize;
}

export enum SpinnerSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE'
}
